<template>
  <div class="wrapper--pageform">
    <div class="mt-5">
      <label for="page-title" class="form__label"><span class="ic-label"><img src="../assets/img/icon/phapa@2x.png" width="25px" /></span>ตั้งชื่อกองผ้าป่า</label>
      <input type="text" class="form-control form__text" name="title" id="page-title" v-model="value.title" :disabled="disabled" />
      <div class="alert alert--error" v-show="$v.$errors['value.title'].empty">กรุณากรอกชื่อกองผ้าป่า</div>
    </div>

    <div class="mt-5">
      <label for="page-message" class="form__label"><span class="ic-label"><img src="../assets/img/icon/message@2x.png" width="25px" /></span>ข้อความเชิญชวน</label>
      <textarea class="form__textarea" id="page-message" v-model="value.message" placeholder="กองผ้าป่านี้เพื่อน้องๆ ได้มีโอกาสทางการศึกษา มาช่วยกันนะ" :disabled="disabled"></textarea>
      <div class="text-remark text-right mt--15" :class="{error: overMaxLength}">{{ value.message.length }}/{{ maxMessageLength }}</div>
      <div class="alert alert--error" v-show="$v.$errors['value.message'].maxLength">จำนวนข้อความต้องไม่เกิน {{ maxMessageLength }} ตัวอักษร</div>
    </div>

    <div class="mt-5 mb-20">
      <label for="page-owner" class="form__label"><span class="ic-label"><img src="../assets/img/icon/person@2x.png" width="25px" /></span>ชื่อ-นามสกุลเจ้าของกองผ้าป่า</label>
      <input type="text" class="form__text" name="owner" id="page-owner" v-model="value.owner" :disabled="disabled" />
    </div>
    <div class="form__item form__item--inline">
      <label class="form__label form__label--title">
        <input class="form__input" type="radio" name="type" value="1" v-model="value.type" :disabled="disabled" />
        <span class="icon _sl-tcfe">&nbsp;</span>สร้างกองผ้าป่าร้อยพลังการศึกษา
      </label>
    </div>
    <div class="tab-remark">
      <div class="label">หรือเลือกประเภทกองผ้าป่า</div>
    </div>
    <div class="form__item form__item--inline">
      <label class="form__label form__label--title">
        <input class="form__input" type="radio" name="type" value="3" v-model="value.type" :disabled="disabled" />
        <span class="icon _sl-school">&nbsp;</span>สร้างกองผ้าป่าให้โรงเรียน
      </label>
      <div class="form__sub-section" v-if="value.type === '3'">
        <div class="form__select">
          <select id="page-province2" v-model="province2" @change="selectProvince" :disabled="disabled">
            <option value="">- เลือกจังหวัด -</option>
            <option v-for="province in provinces" :value="province.id">{{ province.name }}</option>
          </select>
        </div>
        <div class="alert alert--error" v-show="$v.$errors['province2'].empty">กรุณาเลือกจังหวัด</div>
        <div class="form__select" v-if="value.type === '3'">
          <select id="page-school" v-model="value.school" :disabled="disabled">
            <option value="">- เลือกโรงเรียน -</option>
            <option v-for="school in schools" :value="school.id">{{ school.name }}</option>
          </select>
        </div>
        <div class="alert alert--error" v-show="$v.$errors['value.school'].empty">กรุณาเลือกโรงเรียน</div>
      </div>
    </div>
    <div class="form__item form__item--inline">
      <label class="form__label form__label--title">
        <input class="form__input" type="radio" name="type" value="2" v-model="value.type" :disabled="disabled" />
        <span class="icon _sl-province">&nbsp;</span>สร้างกองผ้าป่าให้จังหวัด
      </label>
      <div class="form__sub-section">
        <div class="form__select" v-if="value.type === '2'">
          <select id="page-province" v-model="province" @change="selectProvince" :disabled="disabled">
            <option value="">- เลือกจังหวัด -</option>
            <option v-for="province in provinces" :value="province.id">{{ province.name }}</option>
          </select>
        </div>
        <div class="alert alert--error" v-show="$v.$errors['province'].empty">กรุณาเลือกจังหวัด</div>
      </div>
    </div>


    <div class="alert alert--error" v-show="$v.$errors['value.type'].empty">กรุณาเลือกประเภทการบริจาค</div>

    <div class="_clearfix mt-15">
      <div class="fl-right">
        <button type="button" class="btn" @click.prevent="submit" :disabled="disabled">{{ submitButtonText }}</button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'PageForm',

    props: {
      value: {
        type: Object,
        required: false,
        default: () => {
          return {
            title: '',
            message: '',
            province: '',
            school: '',
            owner: '',
            type: ''
          }
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      submitButtonText: {
        type: String,
        default: 'ต่อไป >>'
      }
    },

    computed: {
      overMaxLength () {
        return this.value.message.length > this.maxMessageLength
      }
    },

    data () {
      return {
        maxMessageLength: 80,
        categories: [],
        provinces: [],
        schools: [],
        province: '',
        province2: '',
        $v: null
      }
    },

    created () {
      // this.$router.push('/')
      if (this.value.province) {
        this.province = this.value.province
        this.province2 = this.value.province
      }
      this.initForm()
      this.initValidator()
      this.getCategories()
    },

    methods: {
      initForm () {
        const fullName = this.$utils.getUserFullName(this.$store)
        if (fullName) {
          this.value.owner = fullName
        }
      },

      initValidator () {
        this.$v = this.$validator.init(this, {
          'value.type': { checkEmpty: true },
          'province': {
            checkEmpty: true,
            dependOn: { field: 'value.type', value: '2' }
          },
          'province2': {
            checkEmpty: true,
            dependOn: { field: 'value.type', value: '3' }
          },
          'value.school': {
            checkEmpty: true,
            dependOn: { field: 'value.type', value: '3' }
          },
          'value.title': { checkEmpty: true },
          'value.message': { maxLength: this.maxMessageLength }
        })
      },

      getCategories () {
        this.$http.get('categories')
        .then(resp => {
          resp.body.categories.forEach(category => {
            try {
              category.data = JSON.parse(category.data)
            } catch (err) {
              console.log(err)
              category.data = {}
            }
            this.categories.push(category)
            this.getProvinces()
            this.getSchool(this.value.province)

            if (this.value.province) {
              this.value.provinceObject = this.categories.find(category => category.id === parseInt(this.value.province))
            }

            if (this.value.school) {
              this.value.schoolObject = this.categories.find(category => category.id === parseInt(this.value.school))
            }
          })
        })
        .catch(err => {
          console.log(err)
          this.$modal.show({
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถดึงข้อมูลได้',
            okButtonText: 'ลองใหม่อีกครั้ง',
            ok: () => {
              window.location.reload()
            }
          })
        })
      },

      getProvinces () {
        this.provinces = this.categories.filter(category => !category.parent_id)
      },

      getSchool (province) {
        this.schools = this.categories.filter(category => category.parent_id === province)
      },

      selectProvince () {
        if (this.value.type === '2') {
          this.getSchool(this.province)
        } else if (this.value.type === '3') {
          this.getSchool(this.province2)
        }
        this.value.school = ''
      },

      submit () {
        if (!this.$v.validate()) {
          this.$forceUpdate()
          this.$utils.scrollToFirstErrors()
          return
        }
        this.$emit('submit', this.value)
      }
    },

    watch: {
      province (newValue) {
        this.value.province = newValue
      },
      province2 (newValue) {
        this.value.province = newValue
      },
      'value.province': function (newValue) {
        this.value.provinceObject = this.categories.find(category => category.id === newValue)
      },
      'value.school': function (newValue) {
        this.value.schoolObject = this.categories.find(category => category.id === newValue)
      },
      'value.type': function () {
        this.province = ''
        this.province2 = ''
        this.value.school = ''
        this.schools = []
      }
    }
  }
</script>

<style lang="scss" scoped>
.wrapper--pageform {
  overflow: hidden;
  .form__item {
    padding: 0 0 10px;
    // border-bottom: 1px solid #ccc;
    margin: 0 0 10px 5px;
    border-radius: 0;
  }
  .form__sub-section {
    margin-left: 30px;
  }
  .ic-label {
    float: left;
    width: 30px;
    img { display: block;}
  }
  .form__label {
    display: inline-block;
    line-height: 1.5em;
    > .icon {
      display: inline-block;
      padding-left: 25px;
      background: url("../assets/img/icon/school@2x.png") no-repeat left center;
      background-size: 25px !important;
      &._sl-province {background: url("../assets/img/icon/location@2x.png") no-repeat left center;}
      &._sl-school {background: url("../assets/img/icon/school@2x.png") no-repeat left center;}
      &._sl-tcfe {background: url("../assets/img/icon/ic-100palang@2x.png") no-repeat left center;}
    }
  }
  .text-remark {
    &.error {
      color: red;
    }
  }
  .tab-remark {
    position: relative;
    text-align: center;
    font-size: 0.9em;
    margin-bottom: 15px;
    &:after {
      content: "";
      border-bottom: 1px solid #ccc;
      width: 100%;
      height: 1px;
      display: block;
      margin-top: -16px;
      margin-bottom: 30px
    }
    // margin-top: -15px;
    > .label {
      background: #989898;
      border-radius: 20px;
      display: inline-block;
      padding: 2px 15px;
      font-weight: 300;
      color: #fff;
    }
  }

}
</style>



// WEBPACK FOOTER //
// PageForm.vue?9d36b478